import rill from "rill";
import set from "@rill/set";

import getAllTemplates from "./all-templates.controller.js";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions.js";

const AllTemplates = (app) => {
  app.at(
    "/all-templates/*",
    rill()
      .use(set("heading", ["Coaching", "Templates"]))
      .setup((app) => {
        app.get(
          "/",
          (ctx, next) =>
            checkOrganizationSectionPermission(
              ctx,
              next,
              ["Templates"],
              "/coaching-portal/athletes"
            ),
          getAllTemplates
        );
      })
  );
};

export default AllTemplates;
